module.exports = __webpack_public_path__ + "static/media/SEDRA SHABBAN.5f5c6f93.png";